
import { Component, Vue } from 'vue-property-decorator'
import Carousel from '@/components/HomeCarousel.vue'
import HomeHeader from './components/HomeHeader.vue'
import HomePageHeader from './components/HomePageHeader.vue'
import HomeMenu from './components/Menu.vue'
import HomeInfoEntries from './components/HomeInfoEntries.vue'
import HomeTitle from './components/HomeTitle.vue'
import Parnters from './components/Parnters.vue'
import Links from './components/Links.vue'
import { homeModuleTitle } from './homeConst'
import { IndexManager } from './manager'
import { IndexService } from './service'
import SelectedCourse from './components/SelectedCourse.vue'
import ProjSystems from './components/HomeProjSystem.vue'
import HomeNews from './components/HomeNews.vue'
import HomePoster from './components/HomePoster.vue'
import HomeCommunications from './components/HomeCommunications.vue'
import HomeContactUs from './components/HomeContactUs.vue'
import MemberCenter from './components/MemberCenter.vue'
import Suspend from '../suspend/index.vue'

@Component({
  name: 'BigScreen',
  components: {
    Carousel,
    HomeHeader,
    HomePageHeader,
    HomeMenu,
    HomeTitle,
    Parnters,
    Links,
    SelectedCourse,
    HomeInfoEntries,
    ProjSystems,
    HomeNews,
    HomePoster,
    HomeCommunications,
    HomeContactUs,
    MemberCenter,
    Suspend
  }
})
export default class extends Vue {
  private homeModuleTitle = homeModuleTitle
  private url = ''

  private indexManager: IndexManager = new IndexManager(new IndexService())

  mounted () {
    // const isProduction = process.env.NODE_ENV === 'prod'
    // if (isProduction) {
    //   this.url = 'http://tcwta.tcwta.org.cn/'
    // } else {
    //   this.url = 'http://localhost:8080'
    // }
    this.url = 'https://tcwta.tcwta.org.cn/'
    // localStorage.removeItem('contactUsInfo')
    // this.gethomeConfig()
    // this.getZixunMenuChild()
  }
}
